import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    global: { type: Boolean, default: false }
  }

  connect() {
    this.instances = new Map()
    this._boundSync = this._syncInstance.bind(this)
    this._boundTurboRender = this._handleTurboRender.bind(this)

    if (this.globalValue) {
      this._initAll(document)
      document.addEventListener("turbo:load", this._boundTurboRender)
      document.addEventListener("turbo:frame-load", this._boundTurboRender)
      document.addEventListener("turbo:render", this._boundTurboRender)
    } else {
      this._initSelect(this.element)
    }
  }

  disconnect() {
    if (this.globalValue) {
      document.removeEventListener("turbo:load", this._boundTurboRender)
      document.removeEventListener("turbo:frame-load", this._boundTurboRender)
      document.removeEventListener("turbo:render", this._boundTurboRender)
    }

    this._destroyAll()
  }

  _handleTurboRender(event) {
    const root = event.target?.querySelectorAll ? event.target : document
    this._initAll(root)
    this._pruneRemoved()
  }

  _initAll(root) {
    const scope = root === document ? document : root
    scope.querySelectorAll("select.form-select").forEach((select) => this._initSelect(select))
  }

  _initSelect(select) {
    if (select.dataset.searchableSelectSkip !== undefined) return
    if (select.tomselect) return

    const instance = new TomSelect(select, {
      plugins: ["dropdown_input"],
      allowEmptyOption: true,
      create: false,
      onChange: () => {
        select.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })

    select.addEventListener("searchable-select:sync", this._boundSync)
    this.instances.set(select, instance)
  }

  _syncInstance(event) {
    const select = event.currentTarget
    if (select.tomselect) {
      select.tomselect.sync()
    }
  }

  _pruneRemoved() {
    for (const [select, instance] of this.instances) {
      if (!document.contains(select)) {
        select.removeEventListener("searchable-select:sync", this._boundSync)
        instance.destroy()
        this.instances.delete(select)
      }
    }
  }

  _destroyAll() {
    for (const [select, instance] of this.instances) {
      select.removeEventListener("searchable-select:sync", this._boundSync)
      instance.destroy()
    }
    this.instances.clear()
  }
}